(function () {
  'use strict';

  /**
   * @author Dahang Xu
   * @description factory of SemafoneCreditCardService load Semafone URL
   * @class ute-ui
   * @memberOf ute-ui
   */

  angular.module('ute.ui')
    .factory('uteSemafoneCreditCardService', _service);

  _service.$inject = ['env','permissionsService', '$rootScope'];

  /* @ngInject */
  function _service(env,permissionsService, $rootScope) {

    var service = {
      loadSemafoneCapturePageUrl: loadSemafoneCapturePageUrl
    };

    return service;

    function loadSemafoneCapturePageUrl(maskedCardNumber, isPanFocusedOnInitialise, isPanResetOnInitialFocus) {
      // if(permissionsService.permissionDetail.isBRTMoneris || !semafoneSwitch.isOn(semafoneSwitch.keys.TOKENIZATION_EVOLUTION)){
      //   var paymentGateway = env.semafoneParameters.moneris;
      // } else if() {
      // }
      // else{
      //   var paymentGateway = env.semafoneParameters.cybersource;
      // }
      var paymentGateway = {};
      paymentGateway = env.semafoneParameters.moneris;
      var semafoneUrl = paymentGateway.semafoneUrl;
      var semafoneMode = paymentGateway.semafoneMode;
      var gatewayId = paymentGateway.gatewayId;
      var methodId = paymentGateway.methodId;
      var ppUserId = paymentGateway.ppUserId;
      var ppPassword = encodeURIComponent(paymentGateway.ppPassword);
      var tenantId = paymentGateway.tenantId;
      var clientId = paymentGateway.clientId;
      var accountId = paymentGateway.accountId;
      var principle = paymentGateway.principle;
      var licenseCode = paymentGateway.licenseCode;
      var transactionType = paymentGateway.transactionType;
      var responseType = paymentGateway.responseType;
      var responseURL = paymentGateway.responseURL;
      // var lang = localStorage();
      var lang = 'en'; // Need to read it from local storage
      //var isPanFocusedOnInitialise = false;
      var elementFontSize = '18';
      var elementWidth = '400';
      var elementMaxLength = '16';
      var maskedPan = paymentGateway[lang];
      var url = '';

      //if (angular.element('#maskedCardNumber').length > 0 && angular.element('#maskedCardNumber').val().length >
      //    0) {
      //    maskedPan = angular.element('#maskedCardNumber').val();
      //}
      if (maskedCardNumber.length > 0) {
        maskedPan = maskedCardNumber;
      }
      //alert("inside maskedPan : "+maskedPan);
      // var isPanFocusedOnInitialise = false;

      //if (angular.element('#isPanFocusedOnInitialise').length > 0 && angular.element(
      //        '#isPanFocusedOnInitialise').val().length > 0) {
      //    isPanFocusedOnInitialise = angular.element('#isPanFocusedOnInitialise').val();
      //}

      //var isPanResetOnInitialFocus = true;
      //
      //if (angular.element('#isPanResetOnInitialFocus').length > 0 && angular.element(
      //        '#isPanResetOnInitialFocus').val().length > 0) {
      //    isPanResetOnInitialFocus = angular.element('#isPanResetOnInitialFocus').val();
      //}

      //alert('isPanResetOnInitialFocus  :: '+isPanResetOnInitialFocus);

      if (semafoneMode !== 'UNKNOWN' && methodId !== 'UNKNOWN') {
        if (methodId === 'TOKENISE') {
          if (semafoneMode === 'DISABLED') {
            url = semafoneUrl + '?semafoneMode=' + semafoneMode +
              '&gatewayId=' + gatewayId + '&methodId=' + methodId +
              '&ppUserId=' + ppUserId + '&ppPassword=' + ppPassword +
              '&tenantId=' + tenantId + '&clientId=' + clientId +
              '&accountId=' + accountId + '&principle=' + principle +
              '&licenseCode=' + licenseCode + '&responseType=' + responseType +
              '&transactionType=' + transactionType + '&maskedPan=' +
              maskedPan + '&isPanFocusedOnInitialise=' +
              isPanFocusedOnInitialise + '&isPanResetOnInitialFocus=' +
              isPanResetOnInitialFocus + '&elementFontSize=' +
              elementFontSize + '&elementWidth=' + elementWidth +
              '&elementMaxLength=' + elementMaxLength + '&responseURL=' +
              responseURL;
            // alert('url :: '+url);
            return url;
          } else {
            //Error condition: Invalid semafoneMode
          }
        } else {
          //Error condition: Invalid methodId
        }
      } else {
        //Error condition: methodId or semafoneMode not specified
      }

    }
  }
})();
